/**
 * The unsaved-changes guard for the Account page's sections (TMMRSL-0071). React Router supports ONE
 * blocker at a time, and Profile and Password share a page, so `AccountScreen` owns the single guard
 * and the sections report their dirty state upward (`onDirtyChange`). A section used on its own
 * (no `onDirtyChange`) renders its own guard through `SectionGuard`.
 */
import type { ReactNode } from 'react';
import { useUnsavedGuard } from '@/components/useUnsavedGuard';

/** The standalone guard of one section; rendered only when the parent doesn't own the guard. */
export function SectionGuard({ when, name }: { when: boolean; name: string }): ReactNode {
  return useUnsavedGuard({ when, name });
}
